import React from 'react';
import { IconProps } from '.';

const SvgColoredCoupon = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#7E96F9'
        d='M1.333 4h14.914l1.886 1.886L20.018 4h2.649C23.403 4 24 4.597 24 5.333v13.334c0 .736-.597 1.333-1.333 1.333h-2.649l-1.885-1.885L16.247 20H1.333A1.333 1.333 0 0 1 0 18.667V5.333C0 4.597.597 4 1.333 4Z'
      />
      <path
        fill={color}
        d='M11.734 14.267a.933.933 0 1 1-1.867 0 .933.933 0 0 1 1.867 0ZM7.2 9.734a.933.933 0 1 1-1.867 0 .933.933 0 0 1 1.867 0Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M5.968 14.566a.8.8 0 0 1 0-1.132l4-4a.8.8 0 0 1 1.13 1.132l-4 4a.8.8 0 0 1-1.13 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredCoupon;
